/**
 * @flow
 */
'use strict';

export const lidLashesCodes =  [[
  {"code":"1+ "},
  {"code":"2+ "},
  {"code":"3+ "},
  {"code":"4+ "}
],[
  {"code":"WNL"},
  {"code":"Meibomianitis"},
  {"code":"Blepharitis"},
  {"code":"Chalazion"},
  {"code":"Hordeolum"},
  {"code":"GPC"},
  {"code":"Districhiasis"},
  {"code":"Trichiasis"}
],[
  {"code":" 1+"},
  {"code":" 2+"},
  {"code":" 3+"},
  {"code":" 4+"}
],[
  {"code":" Meibomianitis"},
  {"code":" Blepharitis"},
  {"code":" Chalazion"},
  {"code":" Hordeolum"},
  {"code":" GPC"},
  {"code":" Districhiasis"},
  {"code":" Trichiasis"}
]]

export const conjunctivaCodes = [[
  {"code":"1+ "},
  {"code":"2+ "},
  {"code":"3+ "},
  {"code":"4+ "}
],[
  {"code":"WNL"},
  {"code":"Injection"},
  {"code":"Pinguecula"},
  {"code":"Pterygium"},
  {"code":"Chemosis"},
]]

export const corneaCodes = [[
  {"code":"1+ "},
  {"code":"2+ "},
  {"code":"3+ "},
  {"code":"4+ "}
],[
  {"code":"SPK"},
  {"code":"Clear"},
  {"code":"KP"},
  {"code":"Opacities"},
  {"code":"Neovascularization"},
  {"code":"Dystrophy"},
  {"code":"Arcus"},
  {"code":"Flap Scars"},
  {"code":"Pigment Dispersion"},
]]

export const aCSuffixCodes = [
{"code":"D&Q"},
{"code":"+ Cells"},
{"code":"+ Flare"}
]

export const irisCodes = [
{"code":"Flat/Clear"},
{"code":"Narrow Periph"},
{"code":"Anisocoria"}
]

export const lensCodes = [[
  {"code":"1+ "},
  {"code":"2+ "},
  {"code":"3+ "},
  {"code":"4+ "}
],[
  {"code":"Clear"},
  {"code":"NSC"},
  {"code":"ACC"},
  {"code":"PCC"},
  {"code":"PSC"},
  {"code":"BRUNESCENT"},
  {"code":"PCIOL"},
  {"code":"ACIOL"}
]]
